import actions from "./actions";

const initState = {
    getOutsideEMailLoading: false,
    getOutsideEMailError: null,
    getOutsideEMailByMessage: null,
    getOutsideEMailResult: [],
    readOutsideEMailLoading: false,
    readOutsideEMailError: null,
    readOutsideEMailMessage: null,
    showNoDataFlag: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_OUTSIDE_EMAIL:
            return {
                ...state,
                getOutsideEMailLoading: true,
                getOutsideEMailError: null,
                getOutsideEMailByMessage: null,
                showNoDataFlag: false,
            };
        case actions.GET_OUTSIDE_EMAIL_SUCCESS:
            return {
                ...state,
                getOutsideEMailLoading: false,
                getOutsideEMailError: null,
                getOutsideEMailByMessage: null,
                getOutsideEMailResult: action.payload.data,
                showNoDataFlag: true,
            };
        case actions.GET_OUTSIDE_EMAIL_FAIL:
            return {
                ...state,
                getOutsideEMailLoading: false,
                getOutsideEMailError: action.payload.error,
                getOutsideEMailByMessage: null,
                getOutsideEMailResult: [],
                showNoDataFlag: false,
            };

        case actions.READ_OUTSIDE_EMAIL:
            let temp1 = state.getOutsideEMailResult.map((item) => {
                let temp = item;
                if (item.ID == action.payload.mailID) {
                    temp.showMail = !temp.showMail;
                } else {
                    temp.showMail = false;
                }
                return temp;
            });
            return {
                ...state,
                readOutsideEMailLoading: true,
                readOutsideEMailError: null,
                readOutsideEMailMessage: null,
                getOutsideEMailResult: temp1
            };

        case actions.READ_OUTSIDE_EMAIL_SUCCESS:
            let temp3 = state.getOutsideEMailResult.map((item) => {
                let temp = item;
                if (item.ID == action.payload.mailID) {
                    temp.IsRead = 1;
                }
                return temp;
            });
            return {
                ...state,
                readOutsideEMailLoading: false,
                readOutsideEMailError: null,
                readOutsideEMailMessage: action.payload.message,
                getOutsideEMailResult: temp3
            };

        case actions.READ_OUTSIDE_EMAIL_FAIL:
            return {
                ...state,
                readOutsideEMailLoading: false,
                readOutsideEMailError: null,
                readOutsideEMailMessage: null,
            };

        case actions.CLOSE_OUTSIDE_EMAIL_TEMPLATE:
            let temp2 = state.getOutsideEMailResult.map((item) => {
                let temp = item;
                if (item.ID == action.payload.mailID) {
                    temp.showMail = !temp.showMail;
                }
                return temp;
            });
            return {
                ...state,
                readOutsideEMailLoading: false,
                readOutsideEMailError: null,
                readOutsideEMailMessage: null,
                getOutsideEMailResult: temp2
            };

        case actions.RESET_EMAIL_TEMPLATE_DATA:
            return {
                ...state,
                getOutsideEMailResult: [],
            };

        default:
            return state;
    }
}